import { render, staticRenderFns } from "./headerAsistente.vue?vue&type=template&id=b4055456&"
import script from "./headerAsistente.vue?vue&type=script&lang=js&"
export * from "./headerAsistente.vue?vue&type=script&lang=js&"
import style0 from "./headerAsistente.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports